import { images } from "../constants";

const home = {
        image: images.home, // Home Image
        subtitle: "2025年11月26日 - 29日 | 就在台北市", // Event Dates & Location
        headingPart1: "",
        spanText: "主題：AI機器科技創意",
        headingPart2: "為我們的未來發揮無限的創意",
        buttonText: "註冊",
        buttonLink: "https://forms.gle/Mn89fLtedYEhpmw28",
};

export default home;